export const tariffsTableStyles = {
  header: {
    fontSize: 14,
    color: '#1a171b',
    backgroundColor: 'rgba(0, 65, 101, 0.1)',
    border: 'none',
  },
  cell: {
    height: "40px",
    fontSize: 14,
    color: '#63666a',
    backgroundColor: '#FFFFFF',
    padding: '0 20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}
